import { AfterContentChecked, Component, ElementRef, ErrorHandler, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { format, parseJSON } from 'date-fns';
import { BetService } from 'src/app/bet.service';
import { BlockConfigurationObject } from 'src/app/block-configuration-object.model';
import { GeneralService } from 'src/app/general.service';
import { LocalisationService } from 'src/app/localisation.service';
import { Match } from 'src/app/match.model';
import { MatchService } from 'src/app/match.service';
import { SportDataService } from 'src/app/sport-data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pre-match-predictions-block',
  templateUrl: './pre-match-predictions-block.component.html',
  styleUrls: ['./pre-match-predictions-block.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class PreMatchPredictionsBlockComponent implements OnInit, OnChanges, AfterContentChecked {

  @Input() configurationObject: BlockConfigurationObject;
	@ViewChild("blockBody") blockBody: ElementRef;

	blockDomain = environment.blockDomain;
	btsDataUnavailable = false;
	displayMaximumWidths = {
		"xxx-compact": 200,
		"xx-compact": 240,
		"x-compact": 350,
		compact: 500,
		"less-compact": 600,
		medium: 699,
		large: 800,
	};
	displayMode = "";
	firstSetDataUnavailable = false;
	gamesError = false;
	gamesLoading = true;
	h2hBettingDataUnavailable = false;
	lineDataUnavailable = false;
	match: Match = null;
	totalDataUnavailable = false;
	noGamesAvailable = false;
	blockInitStarted = false;

	highOpenDataUnavailable = false;
	fourOversDataUnavailable = false;
	firstWicketDataUnavailable = false;
	mostSixesDataUnavailable = false;




	constructor(
		private errorHandler: ErrorHandler,
		public matchService: MatchService,
		public sportDataService: SportDataService,
		public generalService: GeneralService,
		public betService: BetService,
    public localisationService: LocalisationService,
		private el: ElementRef,
	) {}

	prepareBlock(): void {
		this.blockInitStarted = true;

		this.generalService.initialiseBlock(this.el);
		if (typeof window !== "undefined" && typeof document !== "undefined") {
			window.addEventListener("resize", this.checkCompact.bind(this));
		}

		this.matchService.getGeoData().then(() => {
			this.retrieveSingleGame(this.configurationObject.matchID || "");
		}, () => {
			this.retrieveSingleGame(this.configurationObject.matchID || "");
		});
	}

	ngOnInit(): void {
		if (this.configurationObject && !this.blockInitStarted) {
			this.prepareBlock();
		}

	}

	ngAfterContentChecked(): void {

		const element = this.el?.nativeElement;
		if (element && !this.displayMode) {
			this.displayMode = "full";
			Object.keys(this.displayMaximumWidths).forEach(level => {
				if (element && element.offsetWidth <= this.displayMaximumWidths[level]) {
					this.displayMode += ` ${level}`;
				}
			});
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!this.blockInitStarted && changes.configurationObject.currentValue) {
			this.prepareBlock();
		}
	}

	checkCompact(): void {
		let modeString = "full";
		const element = this.blockBody.nativeElement;
		if (element) {
			Object.keys(this.displayMaximumWidths).forEach(level => {
				if (element && element.offsetWidth <= this.displayMaximumWidths[level]) {
					modeString += ` ${level}`;
				}
			});
		}


			this.displayMode = modeString;
	};

	prepareMatchData = (): void => {
		try {


			this.match.MatchData.UserDate = parseJSON(this.match.MatchData.Date);
			try {
				if (this.match && this.match.PreData) {
					this.match.formattedLastUpdated = format(parseJSON(this.match.PreData.LastUpdated), "h:mma, MMM d");
				}

			} catch {
				this.match.formattedLastUpdated = "Not Available";
			}

			if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "h2h")) {
				this.h2hBettingDataUnavailable = true;

			} else {
				this.h2hBettingDataUnavailable = false;
			}

			if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "line")) {
				this.lineDataUnavailable = true;
			} else {
				this.lineDataUnavailable = false;
			}

			if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "bts")) {
				this.btsDataUnavailable = true;
			} else {
				this.btsDataUnavailable = false;
			}

			if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "total")) {
				this.totalDataUnavailable = true;
			} else {
				this.totalDataUnavailable = false;
			}

			if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "firstset")) {
				this.firstSetDataUnavailable = true;
			} else {
				this.firstSetDataUnavailable = false;
			}

			if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "high-open")) {
				this.highOpenDataUnavailable = true;
			} else {
				this.highOpenDataUnavailable = false;
			}

			if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "four-overs")) {
				this.fourOversDataUnavailable = true;
			} else {
				this.fourOversDataUnavailable = false;
			}

			if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "first-wicket")) {
				this.firstWicketDataUnavailable = true;
			} else {
				this.firstWicketDataUnavailable = false;
			}

			if (!this.match.aggregatedBestBets || !this.match.aggregatedBestBets.some(b => b.type === "most-sixes")) {
				this.mostSixesDataUnavailable = true;
			} else {
				this.mostSixesDataUnavailable = false;
			}

			this.gamesLoading = false;

		} catch (err) {
			this.errorHandler.handleError(err);

			this.gamesError = true;
		}
	};

	retrieveSingleGame = (matchid: string): void => {
		this.gamesLoading = true;
		this.gamesError = false;

		const sportCode = matchid.split("_")[0].toUpperCase();
		let bookmakerList: Array<string> = [];
			if (this.configurationObject.sportExclusiveBookmakers
				&& Object.keys(this.configurationObject.sportExclusiveBookmakers).includes(sportCode.toUpperCase())) {
				bookmakerList = [this.configurationObject.sportExclusiveBookmakers[sportCode.toUpperCase()]];
			} else if (this.configurationObject.bookmakers) {
				bookmakerList = this.configurationObject.bookmakers;
			} else if (this.configurationObject.bookmakerThemeSportExceptions
				&& this.configurationObject.bookmakerThemeSportExceptions.includes(sportCode)) {
				bookmakerList = ["tab"];
			} else if (this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme) {
				bookmakerList = [this.configurationObject.oddsProvider || this.configurationObject.bookmakerTheme];
			}

		this.sportDataService.getPreMatchData(matchid, true, bookmakerList)
			.subscribe((match) => {
				this.match = match;

				this.prepareMatchData();
			}, () => {
				this.gamesError = true;
			}
		);
		


	};

	reloadSingleGame = (matchID: string): void => {
		this.retrieveSingleGame(matchID);
	};

}
